module.exports = __webpack_public_path__ + "media/01.92cbfac2.mp3";